( function ($) {
  /**
   * Gestion du scroll infini
   * Exemple d'utilisation :
   *    {include file="pagination.tpl" infiniteScroll=".liste-elements" ...}
   * ou manuellement
   *    jQuery('.liste-elements').infiniteScroll({
            baseURL: addtpl('{$q}', 'montemplate') + '&page=%page%',
            elements: '.liste-elements > *',
            startPage: {$smarty.get.page|default:1|intval},
            totalPages: {ceil($plugin->total_rec/$plugin->page_rec)}
        });
   */

  $.fn.infiniteScroll = function (options) {
    var settings = $.extend({
      // Le conteneur des elements
      container: this,
      // Le selecteur d'éléments à extraire de la réponse ajax (par défaut la 1e classe de l'élément)
      elements: '.' + this.attr('class').split(' ')[ 0 ] + ' > *',
      // Url appelée en Ajax pour récpupérer le contenu. %page% sera remplacé par la page en cours
      baseURL: '',
      // Texte inséré pendant le chargement
      loadingText: '<p>Chargement en cours <i class="fa fa-lg fa-2x fa-circle-notch fa-spin"></i></p>',
      // Texte inséré lorsqu'il n'y a plus d'éléments
      loadingEnd: '<p>Fin des résultats</p>',
      // Classe à ajouter sur les marqueurs de pages
      pageMarkerClass: '',
      // Page de départ
      startPage: 1,
      // Nombre total de pages. Si ce nombre n'est pas connu, le programme continuera tant qu'il y a des éléments
      totalPages: null,
    }, options);

    if (!settings.elements) {
      console.log('infiniteScroll.js : Missing elements !');
      return;
    }
    if (!settings.baseURL) {
      console.log('infiniteScroll.js : Missing baseURL !');
      return;
    }

    if (!jQuery.fn.appear) {
      console.log('infiniteScroll.js : Missing https://github.com/morr/jquery.appear !');
      return;
    }

    if (settings.startPage > 1) {
      history.replaceState(
        { page: settings.startPage },
        document.title,
        window.location.pathname + window.location.search + '#page' + settings.startPage
      );
    }
    var container = settings.container;
    var page = settings.startPage > 0 ? settings.startPage : 1;
    container.after(jQuery('<div class="js-bottom-detector"></div>'));
    container.prepend(jQuery('<div class="js-page-marker ' + settings.pageMarkerClass + '" data-page="' + page + '"></div>'));
    jQuery('.js-bottom-detector').appear();

    function loadPage(page) {
      return jQuery.ajax(settings.baseURL.replace('%page%', page), {
        beforeSend: function () {
          jQuery('.js-bottom-detector').html(settings.loadingText);
        }
      }).done(function (response) {
        jQuery('.js-bottom-detector').html('');
        var elements = jQuery(response).find(settings.elements);
        if (elements.length == 0) {
          settings.totalPages = page - 1;
        } else {
          // Insérer le markeur de page
          var label = 'Page ' + page;
          if (settings.totalPages !== null) {
            label += ' / ' + settings.totalPages;
          }
          container.append(jQuery('<div class="js-page-marker ' + settings.pageMarkerClass + '" data-page="' + page + '" id="page' + page + '">' + label + '</div>'));
          container.append(elements);
        }
      });
    }


    if (page <= settings.totalPages || settings.totalPages === null) {
      // Détecter l'état courant
      if (history.state && 'page' in history.state) {
        // Charger les pages jusqu'à la position courante
        for (var i = 2; i <= history.state.page; i++) {
          loadPage(i);
        }
        // Surveiller jusqu'à l'apparition de la page voulue
        var timer = window.setInterval(function () {
          var marker = jQuery('#page' + history.state.page);
          if (marker.length > 0) {
            jQuery('html, body').animate({ scrollTop: marker.offset().top }, 500, function () {
              jQuery('.js-page-marker').appear();
            });
            window.clearInterval(timer);
          }
        }, 100);
        page = history.state.page;
      }
      jQuery(document.body).on('appear', '.js-page-marker', function () {
        page = 1 * jQuery(this).data('page');
        history.replaceState(
          { page: page, },
          document.title,
          window.location.pathname + window.location.search + '#page' + page
        );
      });
      jQuery(document.body).on('appear', '.js-bottom-detector', function () {
        page++;
        if (page <= settings.totalPages || settings.totalPages === null) {
          loadPage(page).done(function () {
            jQuery('.js-page-marker').appear();
          });
        } else if (page > settings.totalPages) {
          jQuery('.js-bottom-detector').html(settings.loadingEnd);
          jQuery(document.body).off('appear', '.js-bottom-detector');
        }
      });
    }

  };
}(jQuery) );
